import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, Stack, TextField, Typography } from "@mui/material"
import { PrincipalLayouts } from "../../../layouts"
import { useForm } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { Field } from "../miProfile/Field";
import { addStartup } from "../../helpers";
import { DateInput } from "../DateInput";
import { toEnglishDate } from "../../../helpers/dateFormat";
import { countryList } from "../../../helpers/countryList";


export const AddStartup = () => {

    const { t } = useTranslation('global');
    const navigate = useNavigate();
    const [isWaiting, setIsWaiting] = useState(false);
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);
    const [formValues, handleInputChange, reset] = useForm({ name: '', alias: '', country: 'España', cif: '', registrationDate: toEnglishDate(actualDate), constitutionDate: '', sector: '', url: '' });

    const { name, alias, country, cif, registrationDate, constitutionDate, sector, url } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        addStartup(formValues, t('startupHeaders.successMsg'), t('startupHeaders.errorMsg'), t('startupHeaders.dupCifMsg'), navigate)
        setIsWaiting(false)
        reset()
    }
    const handleCancel = () => {
        reset();
        navigate('/startup')
    }

    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('startupHeaders.titlePage')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack minHeight='calc(100vh - 290px)' gap={2}>

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='startupHeaders' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                        <Field translation='startupHeaders' name={alias} title='alias' handleInputChange={handleInputChange} required={true}/>
                    </Stack>

                    <Stack width='100%' gap={2}>
                        <Field translation='startupHeaders' name={cif} title='cif' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    <Stack width='100%' gap={2}>
                        <Typography variant='overline' color='secondary'>{t('startupHeaders.country')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={countryList}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='country' />}
                            value={country}
                            onSelect={handleInputChange}
                            required
                        />
                    </Stack>

                    <Stack direction='row' width='100%' gap={2}>
                        <DateInput name={registrationDate} title='registrationDate' handleInputChange={handleInputChange} required={true} />
                        <DateInput name={constitutionDate} title='constitutionDate' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='startupHeaders' name={sector} title='sector' handleInputChange={handleInputChange} />
                        <Field translation='startupHeaders' name={url} title='url' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}